module.exports = __webpack_public_path__ + "static/media/tutor-Bimg2m.e2ee7f77.jpg";